import React from 'react'
import Products from '../components/Products'
function AllProducts() {
    return (
        <Products />
    )
}

export default AllProducts